import React from 'react'

import { P } from '@frame/ui-primitives/p'

import { cn } from '@frame/lib/utils/cn'
import { DocumentCardDataAttribute } from '@frame/types'

type Props = { children: string; isUnsupportedType?: boolean }

export function FailureMessage({ children, isUnsupportedType = false }: Props) {
  return (
    <div
      data-cy={DocumentCardDataAttribute.FAILURE_MESSAGE}
      className={cn(
        'flex flex-col justify-center gap-2 rounded-sm bg-error-200 px-4 py-2',
        isUnsupportedType && 'bg-moss-200'
      )}
    >
      <P>{children}</P>
    </div>
  )
}
